import './Number.css'
const Number = () => {
    return (
        <>
            {/* Numbers */}
            <div className="numbers">
                <div className="number wow slideInLeft" data-wow-duration="1s" data-wow-delay="0.3s">
                    <h3>130+</h3>
                    <p>expert trainers</p>
                </div>
                <div className="number wow slideInLeft" data-wow-duration="1.5s" data-wow-delay="0.3s">
                    <h3>950+</h3>
                    <p>member joined</p>
                </div>
                <div className="number wow slideInLeft" data-wow-duration="2s" data-wow-delay="0.3s">
                    <h3>100+</h3>
                    <p>fitness programs</p>
                </div>
            </div>
            {/* Numbers */}
        </>
    );
}

export default Number;
